module.exports = __webpack_public_path__ + "img/inlinelogo.b3b9f1e6.png";